export default "/images/logo.png?9c355b372d4817ae43aa1592a8504e9e";